import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PillModal from '../pillmodals/PillModal';
import '../Pill.scss';
import styles from './FilterPill.module.scss';
import Cross from '../../../../../common/Icons/Cross.svg';
import filterDefinitionPropType from '../../../filterDefinitionPropType';

class FilterPill extends Component {
    constructor(props) {
        super(props);

        this.pillRef = React.createRef();
        this.filterTitleRef = React.createRef();
        this.filterValueRef = React.createRef();

        this.state = {
            pinModalRight: false
        };

        this.updateSizingDetails = this.updateSizingDetails.bind(this);
    }

    componentDidMount() {
        this.updateSizingDetails();
        window.addEventListener('resize', this.updateSizingDetails);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.updateSizingDetails();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateSizingDetails);
    }

    getDisplayMessage() {
        if (this.props.filterError) {
            return '!';
        }

        if (fp.get('props.filterDefinition.displayNumberSelected')(this)) {
            return `${this.props.filter.value.length} selected`;
        }

        return this.props.displayValue;
    }

    updateSizingDetails() {
        this.setState({
            pinModalRight: window.innerWidth - this.pillRef.current.offsetLeft < 224
        });
    }

    render() {
        return (
            <div className={ styles.pillWrapper }>
                <div
                    tabIndex="0"
                    role="button"
                    ref={ this.pillRef }
                    className={ classnames({
                        [styles.pill]: true,
                        [styles.filterPill]: true,
                        'modal-open': this.props.isOpen,
                        disabled: this.props.disabled,
                        error: this.props.filterError
                    }) }
                    onClick={ (e) => {
                        if (
                            e.target !== e.currentTarget
                            && !this.filterTitleRef.contains(e.target)
                            && !this.filterValueRef.contains(e.target)
                        ) {
                            return null;
                        }

                        if (this.props.disabled) return null;

                        return this.props.isOpen
                            ? this.props.openFilter(null)
                            : this.props.openFilter(this.props.filter.title);
                    } }
                >
                    <span className={ styles.filterTitleDisplay } ref={ (node) => { this.filterTitleRef = node; } }>
                        { this.props.filter.title }
                    </span>
                    <span className={ styles.filterValueDisplay } ref={ (node) => { this.filterValueRef = node; } }>
                        { this.getDisplayMessage() }
                    </span>
                    { this.props.fixed || this.props.disabled ? null : (
                        <button
                            className={ classnames({
                                [styles.removeFilterButton]: true,
                                [styles.button]: true
                            }) }
                            type="button"
                            onClick={ () => { this.props.removeFilter(this.props.filter.title); } }
                        >
                            <img className={ styles.svg } src={ Cross } alt="" />
                        </button>
                    ) }
                    { this.props.isOpen && !this.props.disabled ? (
                        <PillModal
                            title={ this.props.filter.title }
                            filter={ this.props.filter }
                            filterError={ this.props.filterError }
                            closeFilter={ () => { this.props.openFilter(null); } }
                            value={ this.props.filter.value }
                            updateFilter={ this.props.updateFilter }
                            type={ this.props.filter.type }
                            getAvailableListValues={ this.props.getAvailableListValues }
                            pushRight={ this.state.pinModalRight }
                            filterDefinition={ this.props.filterDefinition }
                        />
                    ) : null }
                </div>
            </div>
        );
    }
}

FilterPill.propTypes = {
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.shape({
        type: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.shape({}),
            PropTypes.string,
            PropTypes.number,
            PropTypes.instanceOf(Date),
            PropTypes.arrayOf(PropTypes.string)
        ])
    }),
    displayValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    isOpen: PropTypes.bool,
    openFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    getAvailableListValues: PropTypes.func,
    filterError: PropTypes.shape({}),
    filterDefinition: filterDefinitionPropType
};

FilterPill.defaultProps = {
    isOpen: false,
    fixed: false,
    disabled: false,
    getAvailableListValues: fp.noop,
    filterError: null,
    filterDefinition: null,
    filter: {
        value: null
    }
};

export default FilterPill;
